import React from 'react';

const Room = () => {
    return (
        <div>
            <h1>this is comming soon......</h1>
        </div>
    );
};

export default Room;